import Api from '@/api'
import humps from 'humps'

const resource = 'contracts'

export default {
  fetchCardsList (filters = {}) {
    return Api.get(`/${resource}`, { params: humps.decamelizeKeys(filters) })
  },

  fetchCard (slug) {
    return Api.get(`/${resource}/${slug}`)
  }
}
